import Alert from '@mdi/svg/svg/alert.svg?react';
import React from 'react';
import styled from 'styled-components';
import { Flex } from '../Flex';
import { type FlexProps } from '../Flex/Flex.types';
import { MDIIcon } from '../MDIIcon';
import { type MinorOutageBannerProps } from './OutageBanner.types';

const MinorOutageBanner: React.FC<MinorOutageBannerProps> = ({
  bgColor,
  textColor,
  icon,
  children,
}) => {
  const defaultOutageIcon = <MDIIcon icon={Alert} style={{ marginRight: '5px', fill: '#f54' }} />;
  return (
    <BannerParent alignItems="center" bgColor={bgColor} textColor={textColor}>
      {icon ? icon : defaultOutageIcon}
      {children}
    </BannerParent>
  );
};

const BannerParent = styled(Flex)<
  FlexProps & {
    bgColor: React.CSSProperties['background'];
    textColor: React.CSSProperties['color'];
  }
>`
  height: 50px;
  padding: 0 15px;
  background: ${(p) => (p.bgColor ? p.bgColor : '#ffa000')};
  color: ${(p) => (p.textColor ? p.textColor : 'black')};
`;

export default MinorOutageBanner;
